import { Injectable } from '@angular/core';
import { IOption } from 'ng-uikit-pro-standard';
import { IDisplaySelectViewModel } from 'src/app/share/forms/form-select/form-select.component';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor() { }

  setYearToCompare(noOfYears: number = -1): IDisplaySelectViewModel {

    var startYear: number = new Date().getFullYear() - 1;

    var options: IOption[] = [];

    if (noOfYears > 0) {
      for(var i = noOfYears; i > 0; i--) {
        options.push({ label: String(startYear), value: String(startYear), icon: '' });
        startYear--;
      }
    } else {
      var lastYear: number = 2019;

      for(var i = startYear; i >= lastYear; i--) {
        options.push({ label: String(i), value: String(i), icon: '' });
      }
    }

    const ret: IDisplaySelectViewModel = {
      description: 'Year to Compare',
      options: options
    };
    return ret;
  }

  setLineTypes(tabTitle: string): IDisplaySelectViewModel {

    if (tabTitle == 'Monthly Revenue Total By Year') {
      return {
        description: 'Data Type to Highlight',
        options: [
          { label: 'Year', value: '0', icon: '' },
          { label: 'Revenue', value: '1', icon: '' },
          { label: 'Growth Amount', value: '2', icon: '' },
          { label: 'Growth %', value: '3', icon: '' }
        ]
      };
    }
    if (tabTitle == 'Affiliate Margin') {
      return {
        description: 'Data Type to Highlight',
        options: [
          { label: 'Margin Amount', value: '0', icon: '' },
          { label: 'Margin %', value: '1', icon: '' },
          { label: 'Revenue', value: '2', icon: '' },
          { label: 'Cost', value: '3', icon: '' },
          { label: 'Count', value: '4', icon: '' }
        ]
      };
    }
    return {
      description: 'Data Type to Highlight',
      options: [
        { label: 'Revenue', value: '0', icon: '' },
        { label: 'Trips Count', value: '1', icon: '' },
        { label: 'Average Ticket Price', value: '2', icon: '' },
        { label: 'Average Trip Distance', value: '3', icon: '' },
        { label: 'Average Trip Distance', value: '4', icon: '' }
      ]
    };
  }
}
